import { default as moment } from 'moment-timezone'

module.exports = {
  format: function (date) {
    if (!date) return
    return moment(date).format('YYYY-MM-DD HH:mm')
  },
  utc: function (date) {
    if (!date) return
    return moment(date).utc().format('YYYY-MM-DD HH:mm')
  },
  withSeconds: function (date) {
    if (!date) return
    return moment(date).format('YYYY-MM-DD HH:mm:ss')
  },
  logformat: function (date) {
    if (!date) return
    return moment(date).utcOffset('+0000').format('YYYY-MM-DD HH:mm')
  }
}



// WEBPACK FOOTER //
// ./src/helpers/date.js